import { MonetizationOn } from "@mui/icons-material"
import { Chip, Grid, Tooltip } from "@mui/material"
import { FC } from "react"

export const PriceView: FC<{ price: number | undefined }> = ({ price }) => {

    return <Grid item>
            <Chip label={`${price ?? 'Negotiable'}/=`} color="primary" variant="filled" onDelete={() => console.log('')} deleteIcon={<MonetizationOn />} />
    </Grid>;
}